<template>
    <div id="comPhoneReBind">

        <div class="mybreadcrumb">
            <i class="iconfont icon-yonghushezhi" style="margin-right:10px;color:#999"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>账号资料</el-breadcrumb-item>
                <el-breadcrumb-item>账号绑定</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="phone_mid">
            <div class="img_box">
                <img :src="phonepng" alt="">
                <span class="phone_bind common_fa_fz_co">手机号绑定</span>
            </div>
            <div class="phone_number_box">
                <span class="common_fa_fz_co">当前绑定手机号：</span>
                <span class="common_fa_fz_co">{{userAccount}}</span>
            </div>
            <el-button type="primary" @click="dialogshow">重新绑定</el-button>
        </div>
        
        <el-dialog
            :close-on-click-modal="false"
            title="重新绑定手机号"
            :visible.sync="dialogVisible"
            width="460px"
            min-width='460px'
            class="dialogform">
            <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" 
                label-width="100px" 
                label-position="right" 
                >
                    <el-form-item label="原手机号 :" >
                        <!-- <el-input  v-model="ruleForm.beforePhonum" placeholder="请输入原手机号"  style="width:300px;float:left"></el-input> -->
                        <div style="float:left">{{ruleForm.beforePhonum}}</div>
                    </el-form-item>
                    <el-form-item label="密码 :" prop="password">
                        <el-input  v-model="ruleForm.password" placeholder="请输入密码"  type="password" style="width:300px;float:left"></el-input>
                    </el-form-item>
                    <el-form-item label="新手机号 :" prop="newPhonum"  class="porelative">
                        <el-input  v-model="ruleForm.newPhonum" placeholder="请输新手机号" style="width:300px;float:left"></el-input>
                        <!-- <span class="getcode" v-if="!secondshow" @click="getcode">获取验证码</span>
                        <span class="getcode" v-else>{{content}}s</span> -->
                    </el-form-item>
                    <el-form-item label="验证码 :" prop="verificationcode" style="margin-bottom:0px" class="porelative">
                        <el-input v-model="ruleForm.verificationcode" placeholder="请输入验证码" style="width:300px;float:left"></el-input>
                        <span class="getcode" v-if="!secondshow" @click="getcode">获取验证码</span>
                        <span class="getcode" v-else>{{content}}s</span>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dia_footer">
                <el-button @click="dialogVisible = false" class="btn_style">取 消</el-button>
                <el-button type="primary" @click="conFirBtnClick" class="btn_style" :disabled="isbindDisable">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import phonepng from '../../assets/img/wxzfbpay/phone.png';
import {changeMobileApi,getVerifyCodeApi} from '../../js/orderApi';
export default {
    name:"PhoneReBind",
    data(){
        var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          //console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
        return{
            isbindDisable:false,
            ismobile:false,
            secondshow:false, 
            userAccount:localStorage.getItem("userAccount")?localStorage.getItem("userAccount"):'',
            dialogVisible:false,
            phonepng:phonepng,
            codetimer:null,//验证码定时器
            content:'60',
            ruleForm: {
                beforePhonum: '',
                password:'',
                newPhonum: '',
                verificationcode: ''
            },
            rules: {
                // beforePhonum: [
                //     { require:true,validator: checkPhone, trigger: 'blur' }
                // ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                newPhonum: [
                    {required:true,validator: checkPhone, trigger: 'blur'}
                ],
                verificationcode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 4, max: 8, message: '长度在 4 到 8 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    created(){
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            this.ismobile = true
            } else {
            this.ismobile = false
            }
    },
    methods: {
        dialogshow(){
            if(!this.ismobile){
                this.dialogVisible=true;
                this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
                this.ruleForm.beforePhonum=localStorage.getItem("userAccount")?localStorage.getItem("userAccount"):'';
            })
            }else{
                this.$router.push('/mobilePhoneRebind')
            }
            
        },
        conFirBtnClick(){
            let that=this;
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.isbindDisable=true;
                    changeMobileApi({
                        oldMobile:this.ruleForm.beforePhonum,
                        password:this.ruleForm.password,
                        principal:this.ruleForm.newPhonum,
                        code:this.ruleForm.verificationcode
                    })
                    .then(res=>{
                        console.log(res);
                        if(res.status===200 && res.data.error_code===0){
                            this.isbindDisable=false;
                            this.$message.success('手机号换绑成功,稍后请重新登录！');
                            window.localStorage.setItem('userAccount',this.ruleForm.newPhonum)
                            this.dialogVisible=false;
                            setTimeout(()=>{
                                localStorage.clear()
                                this.$router.push('/login')
                            },1000)
                        }else{
                            this.isbindDisable=false;
                            this.$message.error(res.data.error_msg)
                        }
                    })
                    .catch(err=>{
                        this.isbindDisable=false;
                        if(err.data && err.data.errorMessages){
                            if(err.data.errorMessages[0].indexOf('message')!=-1){
                               let message=JSON.parse(err.data.errorMessages[0])
                                that.$message.error(message.message)
                                
                            }else{
                                that.$message.error(err.data.errorMessages[0]);
                            }
                        }else if(err.data){
                            that.$message.error(err.data);
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getcode(){
            this.$refs.ruleForm.validateField(["newPhonum"], errMsg => {
                //console.log(errMsg);
            if (errMsg) {
                console.log(errMsg)
                //this.$message.error(errMsg);
            } else {
                console.log("校验通过");
                this.daojishi();
               // window.localStorage.setItem('userAccount',this.ruleForm.newPhonum)
                getVerifyCodeApi({
                    "codeType": "BIND",
                    "mobile": this.ruleForm.newPhonum
                })
                .then(res=>{
                    if(res.status===200 && res.data.error_code===0){
                        console.log(res);
                    }else{
                        this.$message.error(res.data.error_code +`  `+res.data.error_msg)
                    }
                })
                .catch(err=>{
                    console.log(err)
                })
            }
            });
        },
        daojishi(){
            let that=this;
            clearInterval(that.codetimer);
            that.codetimer=null;
            that.secondshow=true;
            that.content=60;
            that.codetimer=setInterval(()=>{
                that.content--;
                if(that.content<0){
                    that.secondshow = false;
                    clearInterval(that.codetimer);
                    that.codetimer=null;
                }
            },1000)
        }

    },
    beforeDestroy(){
        let that=this;
        clearInterval(that.codetimer);
        that.codetimer=null
    }
}
</script>

<style lang="scss" scoped>
    #comPhoneReBind{
        min-height: 100%;
        background: #fff;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            align-items: center;
            padding: 13px 0 13px 20px;
            border-bottom: 1px solid #EAEAEA;
        }
        .phone_mid{
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 30px 20px 30px;
            border-bottom: 1px solid #F1F1F1;
            .img_box{
                display: flex;
                align-items: center;
                .phone_bind{
                    margin-left: 20px;
                    vertical-align: middle;

                }
            }
        }
        .dialogform{
            .porelative{
                position: relative;
                .getcode{
                    position: absolute;
                    right: 0px;
                    cursor: pointer;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #0069e0;
                }
            }
            .dia_footer{
                display: flex;
                justify-content: center;
                .btn_style{
                    width: 100px;
                    margin-left: 20px;
                }
            }
            /deep/ .el-form-item{
                width: 380px;
            }

            /deep/ .el-dialog__header{
                background: #0069e0;
                .el-dialog__title{
                    float: left;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #FFFFFF;
                }
                .el-dialog__close{
                    color: #FFFFFF;
                    font-size: 22px;
                }
            }
        }
        
        .common_fa_fz_co{//通用字体
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
        }

    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanyPhoneBind.vue